import { TypedDefinition } from '@rehaje/core'

import type { TypedSchema } from '@rehaje/core'

export class ActionCallQueryDefinition extends TypedDefinition {
  override extends = ['Action']
  override properties: TypedSchema[] = [
    {
      name: 'props',
      properties: [
        {
          name: 'queryId',
          type: 'Schema.Union',
          types: [
            {
              expect: {
                type: 'Schema.String'
              },
              type: 'Schema.Mustache'
            },
            {
              type: 'Schema.String'
            }
          ]
        },
        {
          name: 'params',
          type: 'Schema.Object'
        }
      ],
      type: 'Schema.Object'
    }
  ]

  override relationTo = 'Schema.Action'
}
